/**
 * 店舗関連のQuery Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getSellers } from '@/lib/api/seller';
import { sellerKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 店舗一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useSellers(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: sellerKeys.list(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getSellers(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
